import { createSelector } from "@ngrx/store";

import * as fromRoot from "#core/router-store";
import * as fromFeature from "../reducers";
import * as fromCourses from "../reducers/teacher-classes.reducer";
import * as selectorsHelperFn from "#helpers/selectors.helper";
import { Course } from "cli-types";

// Now, one level down from 'coursesModule' in our state tree
// Courses state
// In createSelector, we essential build the path to the state we want
// getCoursesModuleState = top level of state tree: coursesModule
export const getCoursesState = createSelector(
    fromFeature.getCoursesModuleState,
    (state: fromFeature.CoursesState) => state.courses
);

// these select individual properties on a Course State (data, loading, loaded)
// using the entities, this returns a data object (used for high-performance reading, updating & removing)
export const getCoursesEntities = createSelector(
    getCoursesState,
    fromCourses.getCoursesEntities
);

export const getDropdownCoursesEntities = createSelector(
    getCoursesState,
    fromCourses.getDropdownCoursesEntities
);

// gets a teacher-class via id that's passed in (not via route)
export const getCourseById = (id: number) =>
    createSelector(getCoursesEntities, (courses) => courses.get(id));

// get individual teacher-class
export const getCourseByRoute = createSelector(
    // teacher-classes state (list of all teacher-classes)
    getCoursesEntities,
    // url state (current url)
    fromRoot.getRouterState,
    // returns the teacher-class based off url param
    (entities, router): Course | null => {
        return selectorsHelperFn.getSelectedEntity<Course>(
            entities,
            router,
            "courseID"
        );
    }
);

// this takes data object from 'getCoursesEntities' (above)
// and converts it to a data array so the view can be populated
export const getAllCourses = createSelector(getCoursesEntities, (entities) => {
    return Array.from(entities.values());
});

export const getCoursesLoaded = createSelector(
    getCoursesState,
    fromCourses.getCoursesLoaded
);

export const getCoursesLoading = createSelector(
    getCoursesState,
    fromCourses.getCoursesLoading
);

export const getCoursesRawResponse = createSelector(
    getCoursesState,
    fromCourses.getCoursesRawResponse
);

export const getCoursesPaginationParams = createSelector(
    getCoursesState,
    fromCourses.getCoursesPaginationParams
);

export const getSelectedCourseObject = createSelector(
    getCoursesState,
    fromCourses.getSelectedCourseObject
);

export const getDropdownCourses = createSelector(
    getDropdownCoursesEntities,
    (dropdownEntities) => {
        if (!dropdownEntities) {
            return null;
        }
        return Array.from(dropdownEntities.values());
    }
);

export const getDropdownCoursesLoaded = createSelector(
    getCoursesState,
    fromCourses.getDropdownCoursesLoaded
);

export const getDropdownCoursesLoading = createSelector(
    getCoursesState,
    fromCourses.getDropdownCoursesLoading
);

export const getCourseFilterBoxOpened = createSelector(
    getCoursesState,
    fromCourses.getCourseFilterBoxOpened
);

export const getCoursesBackground = createSelector(
    getCoursesState,
    fromCourses.getCoursesBackground
);

// Commenting out for PAS-11616
// export const getBackgroundImage = createSelector(
//     getCoursesState,
//     fromCourses.getBackgroundImage
// );

// export const getBackgroundImageLoading = createSelector(
//     getCoursesState,
//     fromCourses.getBackgroundImageLoading
// );

// export const getBackgroundImageLoaded = createSelector(
//     getCoursesState,
//     fromCourses.getBackgroundImageLoaded
// );

export const getFidoStudentsDataFromCourses = createSelector(
    getCoursesState,
    fromCourses.getFidoStudentsData
);
